const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();




// ------------------------------------------------------------------------
// preLoad
// ----- BOTH
// ------------------------------------------------------------------------
const preLoad = () => {
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// footerSlider
// ----- BOTH
// ------------------------------------------------------------------------
const footerSlider = () => {
  $('.slider-footer').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 500,
    cssEase: 'ease',
    centerMode: true,
    initialSlide: 1,
    variableWidth: true,
    responsive: [
   {
     breakpoint: 768,
     settings: {
       slidesToShow: 2,
       swipe: true,
       edgeFriction: 0.01,
       centerMode: false,
       initialSlide: 0,
     }
   }
 ]
  });
};


// ------------------------------------------------------------------------
// mvSlider
// ----- BOTH
// ------------------------------------------------------------------------
const mvSlider = () => {
  $('.slider-mv').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 3000,
  });
};


// ------------------------------------------------------------------------
// puSlider
// ----- BOTH
// ------------------------------------------------------------------------
const puSlider = () => {
  $('.slider-pickup').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    speed: 500,
    cssEase: 'ease',
    variableWidth: true,
    appendArrows: '#slideNav_Wrap',
    appendDots: '#slideNav_Dots',
    responsive: [
   {
     breakpoint: 768,
     settings: {
       slidesToShow: 1,
       swipeToSlide: true,
       swipe: true,
       edgeFriction: 0.01,
     }
   }
 ]
  });
};


// ------------------------------------------------------------------------
// togglePagetop
// ----- BOTH
// ------------------------------------------------------------------------
const togglePagetop = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 300) {
      $(".st-Pagetop").addClass("visible");
    } else {
      $(".st-Pagetop").removeClass("visible");
    }
  });
};


// ------------------------------------------------------------------------
// resizeHeader
// ----- BOTH
// ------------------------------------------------------------------------
const resizeHeader = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 300) {
      $(".st-Header").addClass("scrolled");
    } else {
      $(".st-Header").removeClass("scrolled");
    }
  });
};

// ------------------------------------------------------------------------
// comicSlider
// ----- BOTH
// ------------------------------------------------------------------------
const comicSlider = () => {
  $('.slider-comic').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'ease',
    customPaging: function(slick,index) {
        var targetImage = slick.$slides.eq(index).find('.img').attr('data-src');
        return '<button style="background:url(' + targetImage + ') no-repeat center center/contain"/>';
    }
  });
};

// ------------------------------------------------------------------------
// goodsSlider
// ----- BOTH
// ------------------------------------------------------------------------
const goodsSlider = () => {
  const $slide = $('.slider-goods');
  $slide.on('init', function(event, slick){ $.extend(slick,{ clonedSlides : $(this).find('.slick-cloned')})});
  $slide.on('beforeChange', function(event, slick, currentSlide, nextSlide){ slick.clonedSlides.addClass('slick-current-clone'); });
  $slide.on('afterChange', function(event, slick, currentSlide){ slick.clonedSlides.removeClass('slick-current-clone'); });
  $slide.slick({
    infinite: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    focusOnSelect: true,
    dots: true,
    appendArrows: '#slideNav_Wrap',
    appendDots: '#slideNav_Dots',
    responsive:[
      {
          breakpoint: 768,
          settings:{
              slidesToShow:1,
          }
      },
    ]
  });
};


// ------------------------------------------------------------------------
// toggleMenu
// ----- BOTH
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.st-Header .hamburger button').on('click', function() {
    $(this).toggleClass("open");
    $(".st-Header nav").toggleClass("open");
    $(".st-Header_Inner").toggleClass("open");
  });
};

// ------------------------------------------------------------------------
// scrollAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnime = () => {
  $(window).on('scroll load', function() {
    $('.js-anim').each(function() {
      let targetPos = $(this).offset().top;
      let scrollPos = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scrollPos > targetPos - windowHeight + windowHeight / 8) {
        $(this).addClass("animated")
      }
    });
  });
};


// ------------------------------------------------------------------------
// popupImage
// ----- BOTH
// ------------------------------------------------------------------------
const popupImage = () => {
  let trg = 0;
  $('.popup-toggle').on('click', function() {
    trg = 1;
    let source = $(this).data('source');
    $('.sw-Popup_Box_Inner').children('img').attr('src', source);
    $(".sw-Popup").toggleClass("open");
  });
  $('.sw-Popup_Close , .sw-Popup_Base').on('click', function() {
    trg = 0;
    $(".popup-toggle").toggleClass("open");
    $(".sw-Popup").toggleClass("open");
    setTimeout(function(){$('.sw-Popup_Box_Inner').children('img').attr('src', '');},500);
  });
  $(window).on('scroll', function() {
    if(trg == 1) {
      trg = 0;
      $(".popup-toggle").toggleClass("open");
      $(".sw-Popup").toggleClass("open");
      setTimeout(function(){$('.sw-Popup_Box_Inner').children('img').attr('src', '');},500);
    }
  });
};


export {
  preLoad,
  anchorLink,
  mvSlider,
  puSlider,
  footerSlider,
  togglePagetop,
  resizeHeader,
  comicSlider,
  goodsSlider,
  toggleMenu,
  scrollAnime,
  popupImage
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js